export default "__VITE_ASSET__DADcnUCj__"